<template>
  <v-app id="mainapp-container">
    <component v-bind:is="layout()"></component>
  </v-app>
</template>

<script lang="ts">
import {Component, Vue} from "vue-property-decorator"

@Component({})
export default class App extends Vue {
  layout() {
    return (this.$route && this.$route.meta && this.$route.meta.layout ? this.$route.meta.layout : "app") + "-layout"
  }
}
</script>

<style lang="scss">
.data-item {
  display: flex;
  .label {
    font-size: 12px;
    text-transform: uppercase;
  }
  .label::after {
    content: " :";
  }
  .value {
    font-size: 12px;
    font-weight: bold;
    margin-left: 5px;
  }
}

.no-wrap {
  white-space: nowrap;
}
.para {
  white-space: pre-line;
}
.margin-right-nav {
  margin-right: 36px;
}
.pointer {
  cursor: pointer;
}
.v-label {
  font-size: 14px !important;
}
.flat-expanssion-panel .v-expansion-panel-content__wrap {
  padding: 0px !important;
  margin: 0px;
}
.list-plot-lists {
  padding-left: 16px !important;
  list-style-type: square
}
</style>
